import Axios from 'axios';

import { FLOWCHART_API_URL } from '@/config';
import { queryClient } from '@/lib/react-query';
import storage from '@/utils/storage';
import { useNotificationStore } from '@/stores/notifications';
import { logoutUser } from '@/features/auth/api/logout.api';

function authRequestInterceptor(config) {
  const token = storage.getToken();
  if (token) {
    config.headers.authorization = `Bearer ${token}`;

    const { tenantId, userId, userRole } = JSON.parse(
      atob(token.split('.')[1])
    );
    config.headers['x-tenant-id'] = tenantId;
    config.headers['x-user-id'] = userId;
    config.headers['x-user-role'] = userRole;
  }

  config.headers.Accept = 'application/json';
  return config;
}

export const axios = Axios.create({
  baseURL: FLOWCHART_API_URL,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const message = error?.response?.data?.message || error?.message;
    const status = error?.response?.status;
    const url = error?.response?.data?.path;

    if (status === 401 && url !== '/api/v1/auth/me/resetpassword') {
      if (url === '/api/v1/auth/login')
        useNotificationStore.getState().addNotification({
          type: 'error',
          title: message,
        });
      else if (url === '/api/v1/auth/google-login') {
        useNotificationStore.getState().addNotification({
          type: 'error',
          title: message,
        });
      } else {
        await logoutUser();
        queryClient.clear();
        localStorage.clear();
        window.dispatchEvent(
          new CustomEvent('logout', { detail: { navigateTo: '/auth/login' } })
        );
      }
    }

    if (status >= 500 || status === 404) {
      useNotificationStore.getState().addNotification({
        type: 'error',
        title: message || 'Something went wrong',
      });
    }
    console.error('API Error -> ', error);
    return Promise.reject(error);
  }
);
